import React from 'react';
import Nav from './Nav'
import { useLocation,Link } from 'react-router-dom';
import { FaPlay } from "react-icons/fa";

const SearchResult = () => {
  const location = useLocation();
  const searchResults = location.state?.searchResults || [];

  return (
    <div>
      <Nav/>
      <div className="mx-auto p-4 lg:container">
        <h1 className='text-center text-2xl py-4'>Search Results</h1>
        <div className='grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-8 p-4'>
          {searchResults.map((result, index) => (
            <div key={index._id}>
              <Link to={`/viewer/viewtrailer/${result._id}`}>
                <div className="containe">
                <img width={700} height={400}  src={`https://naijaserver.cleverapps.io/api/v3/image/${result.coverPhoto}`} className="image rounded-lg h-64" alt="" />
                  <div className="middle bg-blue-600 rounded-full p-4 flex items-center justify-center h-14 w-14">
                    <span className="text-white p-4 text-xl"><FaPlay /></span>
                  </div>
                  <div className='p-2 text-center'>
                    <h4>{result.movieName}</h4>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchResult;
